import { render } from "./App.vue?vue&type=template&id=7c5cfec5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7c5cfec5&lang=scss"

import exportComponent from "E:\\Code\\Phaser3\\MillionaireGame\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__